module.exports = __webpack_public_path__ + "static/okinawa-prefectural-university-of-arts-2701e224d48d7feb67569a6c8732a630.png";